import {Button, Classes, MenuItem, Overlay, Switch} from '@blueprintjs/core';
import React, {PureComponent} from 'react';
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InputRegular from '../common/InputRegular';
import {Select} from "@blueprintjs/select";

class CustomFieldModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                new_tag: ''
            },
            overlayIsOpen: false,
            errorsList: [],
            fieldsCheckActive: false,
            spinnerActive: false,
            modalType: this.props.modalType,

            fieldName: this.props.fieldName,
            oldFieldName: this.props.fieldName,

            fieldType: '',
            oldFieldType: this.props.fieldType ? this.props.fieldType : 'Text',

            availablePersonalization: false,
            fieldTypes: ['Text', 'Date', 'Number'],
            reservedField: this.props.reservedField,
            personalizationDisabled: false,
            changedInModal: false
        };
    }

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    handleModalClick = () => {
        const fieldName = this.state.fieldName
        const fieldType = this.state.fieldType
        const fieldNewName = this.state.fieldNewName

        switch (this.state.modalType) {
            case 'delete':
                // console.log('delete: ', fieldName + ' ' + fieldType + ' ' + fieldNewName);
                this.props.handleClose();
                break;
            case 'create':
                // console.log('create', fieldName + ' ' + fieldType + ' ' + fieldNewName);
                this.props.handleClose();
                break;
            case 'edit':
                // console.log('edit', fieldName + ' ' + fieldType + ' ' + fieldNewName);
                this.props.handleClose();
                break;
        }
    }
    triggerPersonalization = () => {
        const availablePersonalization = this.state.availablePersonalization
        this.setState({
            availablePersonalization: !availablePersonalization
        })
    }

    componentDidMount = () => {
        this.setState({
            changedInModal: false,
            overlayIsOpen: this.props.showModal
        })
    }

    componentDidUpdate = () => {
        if (this.props.showModal !== this.state.overlayIsOpen) {
            this.setState({
                changedInModal: false,
                overlayIsOpen: this.props.showModal
            })
        }
        if (this.props.modalType !== this.state.modalType) {
            this.setState({
                modalType: this.props.modalType
            })
        }
        if (this.props.fieldName !== this.state.fieldName && this.state.changedInModal === false) {

            this.setState({
                fieldName: this.props.fieldName
            })
        }
        if (this.props.fieldName !== this.state.oldFieldName) {
            this.setState({
                oldFieldName: this.props.fieldName
            })
        }
        if (this.props.fieldType !== this.state.fieldType && this.state.changedInModal === false) {
            // console.log('cdu field type');
            this.setState({
                fieldType: this.props.fieldType ? this.props.fieldType : 'Text'
            })
        }
        if (this.props.fieldType !== this.state.oldFieldType) {
            this.setState({
                oldFieldType: this.props.fieldType ? this.props.fieldType : 'Text'
            })
        }
        if (this.props.fieldType !== this.state.reservedField) {
            this.setState({
                reservedField: this.props.reservedField
            })
        }
    }
    renderTypes = (item, {modifiers, handleClick}) => {

        return <MenuItem
            key={item}
            text={item}
            value={item}
            active={modifiers.active}
            shouldDismissPopover={true}
            onClick={handleClick}
        />
    }

    typeSelected = (item) => {
        // console.log('type selected: ', item);
        this.setState({
            changedInModal: true
        })
        this.setState({
            fieldType: item
        })
    }

    render() {
        let {visible_modal, closeModal} = this.props;

        return (

            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div id='custom-field-modal' className="modal-field-payment"
                     style={{width: 540}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>{this.state.modalType === 'create' ?

                                'Create New Custom Field' :
                                this.state.modalType === 'edit' ?
                                    'Edit Custom Field'
                                    :
                                    'Delete Custom Field'
                            }</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>
                                <div className='custom-fields-modal-content'>
                                    <div className="custom-fields-modal-inputs">
                                        {this.state.modalType === 'create' || this.state.modalType === 'edit' ?
                                            <React.Fragment>

                                                <InputRegular
                                                    disabled={this.state.reservedField}
                                                    id="1"
                                                    label1="Field Name"
                                                    label2=""
                                                    placeholder="new_field_name"
                                                    type='text'
                                                    value={this.state.fieldName}
                                                    updateErrorsList={this.updateErrorsList}
                                                    errorMessage="Can't be empty"
                                                    required={true}
                                                    onChange={e => this.setState({fieldName: e})}

                                                />

                                                <div className="input-labels-container">
                                                    <label className={this.state.reservedField ? 'disabled' : ''}>Field
                                                        Type</label>
                                                </div>
                                                <Select
                                                    icon="caret-down"
                                                    disabled={this.state.reservedField}
                                                    items={this.state.fieldTypes}
                                                    itemRenderer={(item, index) => <MenuItem
                                                        key={item}
                                                        onClick={() => this.typeSelected(item)}
                                                        text={item}
                                                    />}
                                                    filterable={false}
                                                    resetOnClose={true}
                                                >
                                                    <Button
                                                        icon="caret-down"
                                                        text={this.state.fieldType}
                                                    />
                                                </Select>

                                                {/*<div className="nice-select"*/}
                                                {/*     data-intercom-target="navigation-project-select-nice-select"*/}
                                                {/*     tabIndex="0">*/}
                                                {/*    <div>Text</div>*/}
                                                {/*    <ul className="list">*/}
                                                {/*        <li>Text</li>*/}
                                                {/*        <li>Date</li>*/}
                                                {/*        <li>Number</li>*/}
                                                {/*    </ul>*/}
                                                {/*</div>*/}

                                            </React.Fragment>
                                            :

                                            <React.Fragment>
                                                Are you sure that you want to delete <span
                                                className='text-bold'>{this.state.fieldName}</span> custom field?
                                            </React.Fragment>
                                        }
                                    </div>
                                    {
                                        this.state.modalType !== "delete" ?

                                            <div
                                                className={this.state.personalizationDisabled ? 'available-personalization display-flex justify-content-start disabled'
                                                    : 'available-personalization display-flex justify-content-start'}>
                                                <p>Available in personalization</p>
                                                <Switch checked={this.state.availablePersonalization}
                                                        label="Off"
                                                        onChange={
                                                            this.triggerPersonalization
                                                        }
                                                    //disabled={this.state.reservedField}

                                                />
                                            </div>
                                            : ''
                                    }
                                </div>
                                <div className='justify-content-end flex-direction-row margin-bottom-20'>

                                    <button
                                        disabled={false}
                                        onClick={this.props.handleClose}
                                        name="cancel_tag"
                                        id="cancel_tag"
                                        type="button"
                                        className='btn-white-border margin-right-10'>Cancel
                                    </button>

                                    {!this.state.spinnerActive ?
                                        <button
                                            className={this.state.modalType !== 'delete' ? "btn-action" : 'btn-danger'}
                                            onClick={() => this.handleModalClick()}>
                                            {this.state.modalType === 'create' ?

                                                'Save' :
                                                this.state.modalType === 'edit' ?
                                                    'Save'
                                                    :
                                                    'Delete'
                                            }

                                        </button>
                                        :
                                        <button className={this.state.modalType !== 'delete' ? "btn-action" : 'btn-danger'} disabled={true}>
                                            {this.state.modalType === 'create' ?

                                                'Save' :
                                                this.state.modalType === 'edit' ?
                                                    'Save'
                                                    :
                                                    'Delete'
                                            }
                                            <i
                                                className='fa fa-spin fa-spinner'></i></button>
                                    }

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}

export default CustomFieldModal;